var map = {
	"./error.svg": "KdAw",
	"./info.svg": "jnpC",
	"./success.svg": "Bxnf",
	"./warning.svg": "v5+S"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YhpP";


//////////////////
// WEBPACK FOOTER
// ./src/components/message/src/assets ^\.\/.*\.svg$
// module id = YhpP
// module chunks = 0